export default {
    MUST_EQUIP_AXE: 'You must equip an axe in order to cut trees.',
    MUST_EQUIP_PICKAXE: 'You must be wielding a pickaxe in order to mine rocks.',
    MUST_EQUIP_FISHING: 'You must be wielding a fishing utensil in order to fish.',
    MUST_EQUIP_FORAGING: 'You require a special tool to forage this',

    INVALID_LEVEL_LUMBERJACKING: 'You must be level {{level}} in order to cut this tree.',
    INVALID_LEVEL_MINING: 'You must be level {{level}} in order to mine this rock.',
    INVALID_LEVEL_FISHING: 'You must be level {{level}} in order to fish here.',
    INVALID_LEVEL_FORAGING: 'You must be level {{level}} to harvest this resource.',

    UNABLE_TO_INTERACT_LUMBERJACKING: 'You are unable to cut this tree at the moment.',
    UNABLE_TO_INTERACT_MINING: 'You do not have the necessary knowledge to mine this rock.',
    UNABLE_TO_INTERACT_FISHING: 'You are unable to fish here at the moment.',
    UNABLE_TO_INTERACT_FORAGING: 'You are unable to harvest this resource at the moment.',

    NO_REASON_TREE: 'There is no reason for you to cut this tree.',
    NO_REASON_FISHING: 'There is no reason for you to fish here.'
} as const;
